import { toast } from "react-toastify";

const PrintSummaryReport = (summaryData, reciptDetails, userID) => {
  const list = summaryData?.response || [];

  if (!Array.isArray(list) || list.length === 0) {
    toast.error("No data to print");
    return;
  }

  // SAFE FUNCTIONS
  const hasEncodedEmojiPattern = (value = "") => {
    return /\[Emoji:[^\]]+\]/i.test(value);
  };

  const getSafeCustomerDisplayName = (name, mobile) => {
    const cleanName = String(name || "").trim();

    if (!cleanName) return mobile || "Unknown";

    if (hasEncodedEmojiPattern(cleanName)) {
      return mobile || "Unknown";
    }

    return cleanName;
  };

  const getSafeMode = (mode) => {
    if (!mode || String(mode).trim() === "") return "N/A";
    return mode;
  };

  const totals = summaryData?.data2 || {};

  const totalCashCollectedAmount = parseFloat(
    totals.totalCashCollectedAmount || 0,
  );

  const totalUPICollectedAmount = parseFloat(
    totals.totalUPICollectedAmount || 0,
  );

  const totalCardCollectedAmount = parseFloat(
    totals.totalCardCollectedAmount || 0,
  );

  const totalOrderAmount = parseFloat(
    totals.totalSummaryAmount || summaryData.totalSummaryAmount || 0,
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    const date = new Date(dateStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const receiptInfo = {
    business_name:
      reciptDetails?.business_name ||
      reciptDetails?.businessName ||
      reciptDetails?.organization_name ||
      reciptDetails?.restaurant_name ||
      reciptDetails?.shop_name ||
      reciptDetails?.name ||
      "Chaafo",

    address:
      reciptDetails?.address ||
      reciptDetails?.restaurant_address ||
      reciptDetails?.organization_address ||
      reciptDetails?.business_address ||
      reciptDetails?.shop_address ||
      reciptDetails?.full_address ||
      reciptDetails?.store_address ||
      reciptDetails?.branch_address ||
      reciptDetails?.billing_address ||
      "",

    phone_no:
      reciptDetails?.phone_no ||
      reciptDetails?.phoneNo ||
      reciptDetails?.phone ||
      reciptDetails?.mobile ||
      reciptDetails?.mobile_no ||
      reciptDetails?.mobileNo ||
      reciptDetails?.restaurant_mobile ||
      reciptDetails?.organization_mobile ||
      reciptDetails?.shop_mobile ||
      reciptDetails?.contact_number ||
      reciptDetails?.contactNo ||
      reciptDetails?.contact_no ||
      reciptDetails?.business_mobile ||
      "",

    gst:
      reciptDetails?.gst ||
      reciptDetails?.gst_no ||
      reciptDetails?.gstNo ||
      reciptDetails?.gstNumber ||
      reciptDetails?.gst_number ||
      "",
  };

  const receiptUserId = String(
    reciptDetails?.userid ||
      reciptDetails?.user_id ||
      reciptDetails?.restaurant_userid ||
      reciptDetails?.restaurantUserId ||
      userID ||
      "",
  ).trim();

  const normalizedGST = String(receiptInfo?.gst || "")
    .trim()
    .toUpperCase();

  const showFssai =
    receiptUserId === "A1222" || normalizedGST === "09AADCV8451C1Z9";

  console.log("Summary Report Receipt Details:", reciptDetails);

  const formattedReceiptHTML = `
  <html>
  <head>
    <style>
      body { font-family: Arial, sans-serif; }

      .container {
        max-width: 600px;
        margin: 0 auto;
        padding: 0 4px; 
      }

      .header {
        text-align: center;
        border-bottom: 1px dashed #000;
        margin-top: 10px;
      }

     .header2 {
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
  padding: 5px 0;
   text-align: center;  
}

.headerTotal {
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
  padding: 5px 0;
  font-size: 10px;   
}

      .headerTable {
        margin-top: 10px;
        margin-bottom: 10px;
      }

      .headerEnd {
        text-align: center;
      }

      .textSizeLarge { font-size: 16px; margin: 1px; }
      .textSizeMid { font-size: 11px; margin: 2px; }
      .textSizeSmall { font-size: 9px; }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: none;           
  padding: 6px 4px; 
        font-size: 10px;
        text-align: center;
      }

      .paymentSection {
  border-top: 1px dashed #000;
  border-bottom: 1px dashed #000;
  padding: 5px 0;
  font-size: 10px;
  margin-top: 5px;
}
    </style>
  </head>

  <body>
    <div class="container">

      <!-- HEADER -->
      <div class="header">
       <p class="textSizeLarge"><b>${receiptInfo.business_name}</b></p>
<p class="textSizeMid">${receiptInfo.address}</p>
<p class="textSizeMid">PH: ${receiptInfo.phone_no}</p>
<p class="textSizeMid">GST: ${receiptInfo.gst}</p>
${
  showFssai
    ? `
      <p class="textSizeMid">
        FSSAI NO: 12724052000539
      </p>
    `
    : ""
}
        <p class="textSizeLarge"><b>** SUMMARY REPORT **</b></p>
      </div>

      <!-- DATE -->
      <div class="header2">
  <p class="textSizeMid">Date: ${formatDate(summaryData.fromDate)}</p>
</div>

      <!-- TABLE -->
      <div class="headerTable">
        <table>
          <thead>
            <tr>
              <th>ODR.ID</th>
              <th>MODE</th>
              <th>NAME</th>
              <th>PRICE</th>
            </tr>
          </thead>

          <tbody>
          ${list
            .map((item) => {
              const rawOrderType =
                item?.orderType ||
                item?.order_type ||
                item?.ordertype ||
                item?.orderTypeName ||
                "";

              const orderTypeValue = String(rawOrderType)
                .toLowerCase()
                .replace(/[\s_-]/g, "");

              let orderTypeFormatted = "N/A";

              if (orderTypeValue.includes("home")) {
                orderTypeFormatted = "HWD";
              } else if (orderTypeValue.includes("take")) {
                orderTypeFormatted = "TKW";
              } else if (orderTypeValue.includes("din")) {
                orderTypeFormatted = "DIN";
              } else {
                orderTypeFormatted = String(
                  rawOrderType || "N/A",
                ).toUpperCase();
              }

              console.log("PRINT ORDER TYPE:", {
                rawOrderType,
                orderTypeValue,
                orderTypeFormatted,
                item,
              });

              return `
    <tr>
      <td>${item.daily_order_id || "-"} / ${item.orderid} (${orderTypeFormatted})</td>
      <td>${getSafeMode(item.payment_mode)}</td>
      <td>${getSafeCustomerDisplayName(item.customer_name, item.customer_mobile)}</td>
      <td>${parseFloat(item.totalOrderPrice || 0).toFixed(2)}</td>
    </tr>
  `;
            })
            .join("")}
             
          </tbody>
        </table>
      </div>

<!-- TOTALS -->
<div class="headerTotal">

  <div style="display:flex; justify-content:space-between;">
    <span>Total Cash Collected Amount :</span>
    <span>Rs. ${totalCashCollectedAmount.toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between;">
    <span>Total UPI Collected Amount :</span>
    <span>Rs. ${totalUPICollectedAmount.toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between;">
    <span>Total Card Collected Amount :</span>
    <span>Rs. ${totalCardCollectedAmount.toFixed(2)}</span>
  </div>

  <div style="display:flex; justify-content:space-between; font-weight:700;">
    <span>Total Order Amount :</span>
    <span>Rs. ${totalOrderAmount.toFixed(2)}</span>
  </div>

</div>

      <!-- FOOTER -->
      <div class="headerEnd">
       <p class="textSizeSmall">TKW = Takeaway | HWD = Home Delivery | DIN = Dining</p>
        <p class="textSizeMid"><b>** END OF SUMMARY REPORT **</b></p>
      </div>

    </div>
  </body>
  </html>
  `;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(formattedReceiptHTML);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};

export default PrintSummaryReport;
